import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ModalTeamInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-modal-team-info',
  templateUrl: 'modal-team-info.html',
})
export class ModalTeamInfoPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ModalTeamInfoPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/modal-team-info/modal-team-info.ts